export const PLAYFIELD_ADD_CARD = 'PLAYFIELD_ADD_CARD';
export const PLAYFIELD_REMOVE_CARD = 'PLAYFIELD_REMOVE_CARD';
export const PLAYFIELD_TOGGLE_TAP = 'PLAYFIELD_TOGGLE_TAP';
export const PLAYFIELD_SHOW_BIG_IMG = 'PLAYFIELD_SHOW_BIG_IMG';
export const PLAYFIELD_UPDATE_CARD = 'PLAYFIELD_UPDATE_CARD';
export const SHUFFLE_DECK = 'SHUFFLE_DECK';
export const PLAYFIELD_TOP_CARD_TO_BOT = 'PLAYFIELD_TOP_CARD_TO_BOT';
export const PLAYFIELD_TOGGLE_REVEAL = 'PLAYFIELD_TOGGLE_REVEAL';
export const PLAYFIELD_UNTAP_ALL = 'PLAYFIELD_UNTAP_ALL';
export const PLAYFIELD_CLONE_CARD = 'PLAYFIELD_CLONE_CARD';
export const PLAYFIELD_DRAW_CARD = 'PLAYFIELD_DRAW_CARD';
export const PLAYFIELD_MULLIGAN = 'PLAYFIELD_MULLIGAN';


/** WEBPACK FOOTER **
 ** ./src/components/PlayField/constants.js
 **/